import React from "react";
import { Container, Row, Col  } from "react-bootstrap";
import { Link } from 'react-router-dom'
import CareerImg from '../assets/images/career-img.png'
import ArrowRight2 from '../assets/images/arrow-right-2.svg'
const CareerCompanyFeatures = () => {
  const companyFeatures = [
    {
      id: 1,
      image: CareerImg,
      title: 'Our core',
      description: 'Our efforts to streamline the real estate transaction are supported by a deep-rooted culture of innovation, our passion to redefine the customer experience and a fundamental commitment to engagement & belonging.'
    },
    {
      id: 2,
      image: CareerImg,
      title: 'Benefits',
      description: 'Our benefits are a promise of support and security for every unique individual who chooses to call Real Estate home, as well as that employee’s family. We are committed to designing benefit programs that create a sense of belonging.'
    },
    {
      id: 3,
      image: CareerImg,
      title: 'Flexible work',
      description: 'We’re setting the standard for work experiences of the future, in which our employees are supported in doing their best work and living a flexible, well-balanced life. '
    }
  ]
  return (
    <section className="company-features-section common-padding">
      <Container>
        <div className="common-header text-center">
          <h2>A company where employees thrive</h2>
          <p>Working at Real Estate isn’t just a job it’s a chance to accelerate industry change, grow your career, and help more people get home.</p>
        </div>
        <Row>
          {companyFeatures.map((feature) => (
            <Col lg={4} md={4} sm={12} key={feature.id} className="mb-4 mb-md-0">
              <div className="feature-card">
                <div className="feature-image">
                  <img src={feature.image} alt={feature.title} />
                </div>
                <div className="feature-content">
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        <div className="text-center bttn-group">
          <Link to="/" className="custom-bttn style-3 ani-1">
            Explore Life at Real Estate
            <img src={ArrowRight2} alt="Arrow Right" />
          </Link>
        </div>
      </Container>
    </section>
  );
};

export default CareerCompanyFeatures;
